<template>
  <v-container fluid tag="section">
    <base-material-table
      outlined
      :item="item"
      ref="table"
      @on-add='add'
    >
    </base-material-table>
    <add-view :item='addModal' @on-load-data='loadData'></add-view>
  </v-container>
</template>

<script>
  import { selectData2 } from '@/utils/tool.js'
  import AddView from './components/Add'

  export default {
    name: 'SettingTarget',
    components: {
      AddView
    },
    data() {
      return {
        loading: false,
        addModal: { show: false, data: {} },
        item: {
          path: '/setting/target/list',
          topButtons: [
            { event: 'search', show: true },
            { event: 'add', show: this.$_has("set-target-add") }
          ],
          headers: [
            {
              text: '年份选择',
              hidden: true,
              value: 'year',
              width: 120,
              search: {
                type: 'select',
                itemText: 'label',
                options: () => selectData2()
              }
            },
            {
              text: '目标类型',
              align: 'center',
              divider: true,
              value: 'targetType',
              sortable: false,
              width: 120,
              formatter: (val) => (val === 1 ? '合同额' : '回款额')
            },
            {
              text: '名称',
              align: 'center',
              divider: true,
              value: 'setType',
              sortable: false,
              width: 190,
              formatter: (val, item) => {
                const list = val === 1 ? item.setUsers : item.setDepts
                let name = ''
                list.forEach(i => {
                  name += `${i.name}/`
                })
                return name.substring(0, name.lastIndexOf("/"))
              }
            },
            {
              text: '全年目标',
              align: 'center',
              divider: true,
              value: 'yearTarget',
              width: 120,
              sortable: false
            },
            {
              text: '一月',
              align: 'center',
              divider: true,
              value: 'januaryTarget',
              width: 120,
              sortable: false
            },
            {
              text: '二月',
              align: 'center',
              divider: true,
              value: 'februaryTarget',
              width: 120,
              sortable: false
            },
            {
              text: '三月',
              align: 'center',
              divider: true,
              value: 'marchTarget',
              width: 120,
              sortable: false
            },
            {
              text: '四月',
              align: 'center',
              divider: true,
              value: 'aprilTarget',
              width: 120,
              sortable: false
            },
            {
              text: '五月',
              align: 'center',
              divider: true,
              value: 'mayTarget',
              width: 120,
              sortable: false
            },
            {
              text: '六月',
              align: 'center',
              divider: true,
              value: 'juneTarget',
              width: 120,
              sortable: false
            },
            {
              text: '七月',
              align: 'center',
              divider: true,
              value: 'julyTarget',
              width: 120,
              sortable: false
            },
            {
              text: '八月',
              align: 'center',
              divider: true,
              value: 'augustTarget',
              width: 120,
              sortable: false
            },
            {
              text: '九月',
              align: 'center',
              divider: true,
              value: 'septemberTarget',
              width: 120,
              sortable: false
            },
            {
              text: '十月',
              align: 'center',
              divider: true,
              value: 'octoberTarget',
              width: 120,
              sortable: false
            },
            {
              text: '十一月',
              align: 'center',
              divider: true,
              value: 'novemberTarget',
              width: 120,
              sortable: false
            },
            {
              text: '十二月',
              align: 'center',
              divider: true,
              value: 'decemberTarget',
              width: 120,
              sortable: false
            },
            {
              text: '创建时间',
              align: 'center',
              value: 'createTime',
              width: 120,
              sortable: false,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '操作',
              value: 'actions',
              align: 'center',
              width: 140,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              sortable: false,
              actions: [
                {
                  text: '删除',
                  color: 'warning',
                  icon: 'mdi-delete',
                  onClick: (row, btn) => this.$refs.table.doDelete(row, btn),
                  disable: (row) => !this.$_has('set-target-delete') || (row.setType === 2 && row.setIds === '[1]')
                },
                {
                  text: '编辑',
                  color: 'warning',
                  icon: 'mdi-delete',
                  onClick: (row) => this.addModal = { show: true, data: row },
                  disable: (row) => !this.$_has('set-target-add') || (row.setType === 2 && row.setIds === '[1]')
                }
              ]
            }
          ]
        }
      }
    },
    methods: {
      add () {
        this.addModal = { show: true }
      },
      loadData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style>
</style>
